import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { CONSTANTS } from "../constants/constants";

@Injectable({
  providedIn: "root",
})
export class ResearchService {
  constructor(private readonly http: HttpClient) {}

  headers = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
    }),
  };

  getReSearchReport(PageIndex: number = 1, PageZise: number = 10) {
    const url =
      environment.BASE_API_URL + CONSTANTS.API.RESEARCH.RESEARCH_REPORTS;
    return this.http.get<any>(url, {
      ...this.headers,
      params: {
        PageSize: PageZise.toString(),
        pageIndex: PageIndex.toString(),
      },
    });
  }

  getReSearchInHouse(
    PageIndex: number = 1,
    PageSise: number = 10,
    PoolId: number = 0
  ) {
    const url = environment.BASE_API_URL + CONSTANTS.API.RESEARCH.IN_HOUSE;
    return this.http.get<any>(url, {
      ...this.headers,
      params: {
        pageSize: PageSise.toString(),
        pageIndex: PageIndex.toString(),
        poolId: PoolId.toString(),
      },
    });
  }

  getDownloadResearch(researchId: string) {
    const params = new HttpParams().set("researchId", researchId);
    const url = environment.BASE_API_URL + CONSTANTS.API.RESEARCH.DOCUMENT;
    return this.http.request("GET", url, {
      ...this.headers,
      responseType: "blob",
      params,
    });
  }
}
